angular.module('zc.projects')

.directive 'zcTitleSelectorConfirm', ($filter, BaseProjectConfirm) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.titleSelectorConfirm.pageTitle'), ['og_title', 'title']
  confirm.createDirective confirm.requestRecentHistories



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/title_selector_confirm.directive.coffee